import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import type { UserRole, Permission } from '../types/auth';
import { ROUTE_CONFIG } from '../config/roles';
import LoadingSpinner from './LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
  requiredPermissions?: Permission[];
  requireAuth?: boolean;
  routePath?: string; // Ruta específica para validar acceso
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
  requiredPermissions,
  requireAuth = true,
  routePath,
}) => {
  const { 
    isAuthenticated, 
    user, 
    isLoading, 
    hasPermission, 
    hasRole, 
    canAccessRoute: checkRouteAccess 
  } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner variant="dots" message="Cargando..." />;
  }

  // Si requiere autenticación y no está autenticado
  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Si está autenticado, verificar permisos
  if (isAuthenticated && user) {


    // Si el usuario no tiene permisos cargados, esperar un poco más
    if (!user.permissions || user.permissions.length === 0) {
      return <LoadingSpinner message="Cargando..." size="large" />;
    }


    // Verificar acceso por ruta específica si se proporciona
    if (routePath && !checkRouteAccess(routePath)) {
      return <Navigate to="/unauthorized" replace />;
    } else if (routePath) {
    }

    // Verificar roles permitidos si se especifican
    if (allowedRoles && !hasRole(allowedRoles)) {
      return <Navigate to="/unauthorized" replace />;
    } 

    // Verificar permisos requeridos si se especifican
    if (requiredPermissions && !requiredPermissions.every(permission => hasPermission(permission))) {
      return <Navigate to="/unauthorized" replace />;
    } 

    // Verificar acceso a la ruta actual basado en la configuración
    const currentPath = location.pathname.replace('/admin/', '');

    
    const routeConfig = ROUTE_CONFIG.find(route => 
      route.path === currentPath || currentPath.startsWith(route.path)
    );
    


    if (routeConfig && !checkRouteAccess(currentPath)) {
      return <Navigate to="/unauthorized" replace />;
    } else if (routeConfig) {

    }
  }

  return <>{children}</>;
};